import { useNavigate } from "react-router-dom";
import "../../styles/physio.css";
import { useCurrentLang } from "../../hooks/useCurrentLang";
import { physiosPageContent } from "../../data/physiosPageContent";
export default function PhysioCTA() {
  const navigate = useNavigate();
  const currentLang = useCurrentLang();
  const t = physiosPageContent[currentLang];
  const goPricingPhysio = () => {
    navigate(`/${currentLang}/pricing-physios`)
  }
  const goPhysioWaitlist = () => {
    window.location.href = `https://physios.revimo.eu/signup?lang=${currentLang}`;
  }
  return (
    <section id="cta" className="physio-section physio-cta">
      <div className="glass-card">
        <span className="physio-eyebrow">{t.physioCTA.s}</span>
        <h2>{t.physioCTA.title}</h2>
        <p>
          {t.physioCTA.desc}
        </p>

        <div className="cta-actions">
          <button onClick={goPhysioWaitlist} className="btn-primary-physio">{t.physioCTA.join}</button>
          <button onClick={goPricingPhysio} className="btn-ghost-physio">{t.physioCTA.pricing}</button>

        </div>

        <p className="cta-note">{t.physioCTA.war}</p>
      </div>
    </section>
  );
}
